export default __webpack_public_path__ + "static/media/ic-instagram.974e8fa3.svg";